import { WompiStatus } from "@/entities/api/orders/orders"

export function WompiStatusConvert(status: WompiStatus): string {
	switch (status) {
		case WompiStatus.APPROVED:
			return 'Aprobado'
		case WompiStatus.DECLINED:
			return 'Rechazado'
		case WompiStatus.VOIDED:
			return 'Anulado'
		case WompiStatus.ERROR:
			return 'Error'
		case WompiStatus.PENDING:
			return 'Pendiente'
		default:
			return 'Estado desconocido'
	}
}